import { rest as API } from './rest';

export const createUser = ({ email }) => API.post('/v2/users', { email });

export const getUser = (username) => API.get(`v2/users/${username}`).then(({ data }) => data);

export const getUserAvatar = (username) =>
  API.get(`/v2/users/${username}/avatar?noerror=true`, { headers: { Accept: 'text/plain' } }).then(({ data }) => data);

export const updateUser = (payload) => API.put(`v2/users/${payload.email}`, payload).then(({ data }) => data);

export const setUserPassword = ({ email, password }) => {
  const path = `v2/users/${email}/password`;
  return API.post(path, { password });
};

export const configOTP = (email) => API.post(`v2/users/${email}/otp`).then(({ data }) => data);

export const activate2FA = (email, code) => API.patch(`/v2/users/${email}/otp`, { code }).then(({ data }) => data);

export const deactivate2FA = (email, code) =>
  API.delete(`/v2/users/${email}/otp`, { headers: { 'X-OTP': code } }).then(({ data }) => data);
